module.exports = __webpack_public_path__ + "media/images/lb/642-1c4963d8a7d47a819eed01219a04a9e7.svg";